import { render, staticRenderFns } from "./Esports.vue?vue&type=template&id=66c96a1f&scoped=true"
import script from "./Esports.vue?vue&type=script&lang=js"
export * from "./Esports.vue?vue&type=script&lang=js"
import style0 from "./Esports.vue?vue&type=style&index=0&id=66c96a1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c96a1f",
  null
  
)

export default component.exports